export const list2 = (dispatch, apiClient, query, skipId) => {
  return apiClient
    .call({
      endpoint: 'customersnew/list2',
      data: { query, skipId }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'CUSTOMERSNEW_SET', payload: res.data.results });
      return res;
    });
};

export const get = (dispatch, apiClient, id) => {
  return apiClient
    .call({
      endpoint: 'customersnew/get',
      data: { id }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'CUSTOMERSNEW_SET', payload: res.data });
      return res;
    });
};

export const remove = (dispatch, apiClient, id) => {
  return apiClient
    .call({
      endpoint: 'customersnew/remove',
      data: { id }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'CUSTOMERSNEW_SET', payload: res.data });
      return res;
    });
};

export const create = (dispatch, apiClient, data) => {
  return apiClient
    .call({
      endpoint: 'customersnew/new',
      data: { ...data }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'CUSTOMERSNEW_SET', payload: res.data });
      return res;
    });
};

export const update = (dispatch, apiClient, id, changes) => {
  return apiClient
    .call({
      endpoint: 'customersnew/update',
      data: { id, changes }
    })
    .then(res => {
      console.log(res);
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'CUSTOMERSNEW_SET', payload: res.data });
      return res;
    });
};



// WEBPACK FOOTER //
// ./app/actions/customersNew.js